export const transformShippingContactValidationDto = dto => ({
  regex: dto.regex,
  message: dto.message,
  trackingTarget: dto.tracking_target
});
export const transformShippingContactConfigurationDto = dto => {
  var _dto$phone_number;

  return {
    phoneNumber: {
      validations: ((_dto$phone_number = dto.phone_number) === null || _dto$phone_number === void 0 ? void 0 : _dto$phone_number.validations.map(transformShippingContactValidationDto)) || []
    }
  };
};